import { TabList, TabPanel } from '@mui/lab';
import { Box, styled, Tab } from '@mui/material';

export const CustomTabPanel = styled(TabPanel)`
  padding: 0;
`;

export const CustomTab = styled(Tab)(
  ({ theme }) => `
  &.Mui-selected {
    color: ${theme.palette.brand.charcoal};
    font-weight: 500;
  }

  width: 100%;
  height: 44px;
  max-width: 150px;
  padding: 0;
  color: ${theme.palette.secondary.light};
  font-size: 18px;
  font-weight: 300;
  text-transform: none;
  white-space: nowrap;
  
  &:first-child {
    margin-right: 30px;
  }
`,
);

export const CustomTabList = styled(TabList)`
  padding: 10px 20px 0 20px;
`;

export const ButtonContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
`;
